import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types'
import {Grid, makeStyles, Popover, Slider, Tooltip} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import Input from "@material-ui/core/Input";
import ToggleButton from "@material-ui/lab/ToggleButton";
import FormatBoldIcon from '@material-ui/icons/FormatBold';
import FormatItalicIcon from '@material-ui/icons/FormatItalic';
import FormatUnderlinedIcon from '@material-ui/icons/FormatUnderlined';
import FormatColorText from '@material-ui/icons/FormatColorText';
import FormatColorFillIcon from '@material-ui/icons/FormatColorFill';
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup/ToggleButtonGroup";
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import FormatAlignCenterIcon from '@material-ui/icons/FormatAlignCenter';
import FormatAlignRightIcon from '@material-ui/icons/FormatAlignRight';
import FormatAlignJustify from '@material-ui/icons/FormatAlignJustify';
import ColorPickerPopover from "../ColorPickerPopover";
import _ from "lodash";

const useStyles = makeStyles(() => ({
    iconButton: {
        padding: 0
    },
    popoverContentWrapper: {
        width: 227,
        padding: 7
        // height: 100,
    },
    headerWrapper: {
        height: 30,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    popoverActions: {
        width: '100%',
        textAlign: 'right'
    },
    actionButton: {
        margin: 5
    },
    fontSizeWrapper: {
        width: 211
    },
    fontSizeInput: {
        width: 42
    },
    colorPickWrapper: {
        display: "flex",
        padding: 5
    },
    toggleGroupWrapper: {
        margin: '10px 0'
    },
    toggleButtonGroup: {
        marginTop: 5
    }
}));

const TypographySetup = ({setValues, values, updateOnChange, defaultSize, path, disabled}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [styles, setStyles] = useState({
        fontSize: {size: defaultSize, type: 'px'}, //number + px, //number + px
        textAlign: '', //ONE OF right/center/left/''
        fontStyle: '', //italic or ''
        fontWeight: '', //bold or ''
        textDecoration: '', //underline or ''
        color: '', //string '#ffffff'
        background: '' //string '#ffffff'
    });
    const [initStyles, setInitStyles] = useState({
        fontSize: {size: defaultSize, type: 'px'}, //number + px, //number + px
        textAlign: '', //ONE OF right/center/left/''
        fontStyle: '', //italic or ''
        fontWeight: '', //bold or ''
        textDecoration: '', //underline or ''
        color: '', //string '#ffffff'
        background: '' //string '#ffffff'
    });
    const classes = useStyles();
    function setNewStyles(newStyles) {
        setStyles(prevState => {
            updateOnChange && setValues({...prevState, ...newStyles});
            return {
                ...prevState,
                ...newStyles
            }
        });
    }


    useEffect(() => {
        if(anchorEl) {
            setStyles((styles) => ({...styles, ...values}));
            setInitStyles((initStyles) => ({...initStyles, ...values}))
        }

    }, [path, Boolean(anchorEl)]);

    function onClosePopover() {
        const initValue = {
            fontSize: {size: defaultSize, type: 'px'}, //number + px, //number + px
            textAlign: '', //ONE OF right/center/left/''
            fontStyle: '', //italic or ''
            fontWeight: '', //bold or ''
            textDecoration: '', //underline or ''
            color: '', //string '#ffffff'
            background: '' //string '#ffffff'
        }
        setTimeout(() => {
            setInitStyles(initValue)
            setStyles(initValue)
        }, 500)

        setAnchorEl(null)
    }

    return (
        <>
            <Tooltip title={'Typography Setup'}>
                <IconButton
                    disabled={disabled}
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    className={classes.iconButton}
                    size={"small"}
                >
                    <Icon>
                        format_color_text
                    </Icon>
                </IconButton>
            </Tooltip>
            <TypographyPopover
                styles={styles}
                anchorEl={anchorEl}
                onClose={onClosePopover}
                apply={setValues}
                setStyles={setNewStyles}
                initStyles={initStyles}
                setInitStyles={setInitStyles}

            />
        </>
    )
};
export default TypographySetup;

TypographySetup.defaultProps = {
    setValues: (styles) => {
        console.log(styles)
    },
    values: {
        fontSize: {size: "", type: 'px'}, //number + px
        textAlign: '', //ONE OF right/center/left/''
        fontStyle: '', //italic or ''
        fontWeight: '', //bold or ''
        textDecoration: '', //underline or ''
        color: '', //string '#ffffff'
        background: '' //string '#ffffff'
    }
};
TypographySetup.propTypes = {
    setValues: PropTypes.func.isRequired,
    values: PropTypes.shape({
        fontSize: PropTypes.shape({size: PropTypes.string, type: PropTypes.string}),
        textAlign: PropTypes.oneOf(['left', 'center', 'right', '']),
        fontStyle: PropTypes.oneOf(['italic', '']),
        fontWeight: PropTypes.oneOf(['bold', '']),
        textDecoration: PropTypes.oneOf(['underline', '']),
        color: PropTypes.string,
        background: PropTypes.string,
    })
};

const TypographyPopover = ({anchorEl, apply, styles, setStyles, initStyles, setInitStyles, onClose}) => {
    const classes = useStyles();
    const open = Boolean(anchorEl);
    return (
        <Popover
            style={{width: 400, height: 320}}
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }}
        >
            <div>
                <Header/>
                <Divider/>
            </div>
            <div className={classes.popoverContentWrapper}>
                <Content
                    styles={styles}
                    setStyles={setStyles}
                />
            </div>
            <div className={classes.popoverActions}>
                <Divider/>
                <Actions
                    onClose={() => {
                        onClose();
                        setStyles(initStyles);
                        apply(initStyles)
                    }}
                    apply={() => {
                        apply(styles);
                        setInitStyles(styles);
                        onClose()
                    }}
                />
            </div>
        </Popover>
    )
};

//POPOVER CONTENT
const Content = ({styles, setStyles}) => {
    return (
        <div>
            <FontSizeChange
                fontSize={styles.fontSize}
                setStyles={setStyles}
            />
            <TextFormatChange setStyles={setStyles} styles={styles}/>
        </div>
    )
};

//FONT SIZE CHANGE
const FontSizeChange = ({fontSize = {size: "", type: "px"}, setStyles}) => {
    const classes = useStyles();
    const onChange = (event, newValue) => {
        setStyles({fontSize: {size: newValue, type: 'px'}});
    };
    const onChangeFontInput = (event) => {
        const {target: {value}} = event;
        setStyles({fontSize: {size: value === '' ? '' : Number(value), type: 'px'}});
    };
    const onBlurInput = () => {
        if (fontSize < 0) {
            setStyles((styles) => ({...styles, fontSize: {size: 0, type: 'px'}}))
        } else if (fontSize > 96) {
            setStyles((styles) => ({...styles, fontSize: {size: 0, type: 'px'}}))
        }
    };
    const onChangeFontWeight = (event) => {
        const {target: {value}} = event;
        setStyles({fontWeight: value});
    }
    return (
        <div className={classes.fontSizeWrapper}>
            <Typography color={"textSecondary"}>
                Font Size
            </Typography>
            <Grid container spacing={1} alignItems={'center'}>
                <Grid item xs style={{marginLeft: 7}}>
                    <Slider
                        value={Number(fontSize.size || 0)}
                        max={96}
                        min={0}
                        onChange={onChange}
                    />
                </Grid>
                <Grid item style={{marginTop: -32}}>
                    <Input
                        className={classes.fontSizeInput}
                        value={fontSize.size}
                        margin="dense"
                        onChange={onChangeFontInput}
                        onBlur={onBlurInput}
                        inputProps={{
                            step: 1,
                            min: 0,
                            max: 96,
                            type: 'number'
                        }}
                    />
                </Grid>
            </Grid>
            <Typography color={"textSecondary"}>
                Font Weight
            </Typography>
            <Grid container spacing={1} alignItems={'center'}>
                <Grid item >
                    <Input
                        value={fontSize.weight}
                        name={'fontWeight'}
                        margin="dense"
                        onChange={onChangeFontWeight}
                        inputProps={{
                            step: 100,
                            min: 0,
                            max: 800,
                            type: 'number'
                        }}
                    />
                </Grid>
            </Grid>
        </div>
    )
};

//TEXT STYLE
const TextFormatChange = ({setStyles, styles}) => {
    const classes = useStyles();
    const {fontWeight, fontStyle, textDecoration} = styles;
    const onChangeFormats = (event, formats) => {
        let isBold = _.indexOf(formats, 'bold') !== -1;
        let isItalic = _.indexOf(formats, 'italic') !== -1;
        let isUnderline = _.indexOf(formats, 'underline') !== -1;
        setStyles({
            fontWeight: isBold ? 'bold' : '',
            fontStyle: isItalic ? 'italic' : '',
            textDecoration: isUnderline ? 'underline' : ''
        })
    };
    return (
        <div className={classes.toggleGroupWrapper}>
            <Typography color={"textSecondary"}>
                Text Style
            </Typography>
            <ToggleButtonGroup className={classes.toggleButtonGroup} value={[fontWeight, fontStyle, textDecoration]}
                               onChange={onChangeFormats}
                               aria-label="text formatting">
                <ToggleButton value="bold" aria-label="bold" style={{height: 36, borderRadius: 0, padding: 5}}>
                    <FormatBoldIcon/>
                </ToggleButton>
                <ToggleButton fontSize={"small"} value="italic" aria-label="italic" style={{height: 36, padding: 5}}>
                    <FormatItalicIcon/>
                </ToggleButton>
                <ToggleButton fontSize={"small"} value="underline" aria-label="underlined"
                              style={{height: 36, padding: 5, borderRadius: 0}}>
                    <FormatUnderlinedIcon/>
                </ToggleButton>
                <ColorPick styles={styles} setStyles={setStyles}/>
                <BackgroundPick styles={styles} setStyles={setStyles}/>
                <AlignText styles={styles} setStyles={setStyles}/>
            </ToggleButtonGroup>
        </div>
    )
};

const AlignText = ({styles, setStyles}) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const onChangeAlign = (event, newAlignment) => {
        setStyles({textAlign: newAlignment});
        setAnchorEl(null)
    };
    return (
        <>
            <IconButton
                className={classes.iconButton}
                fontSize={"small"}
                style={{
                    borderRadius: 0,
                    padding: 5,
                    border: '1px solid #d8d8d8',
                    borderLeft: 'none'
                }}
                onClick={(e) => setAnchorEl(e.currentTarget)}
            >
                {styles.textAlign === '' || styles.textAlign === 'left' ? (
                    <Icon>
                        format_align_left
                    </Icon>
                ) : styles.textAlign === 'center' ? (
                    <Icon>
                        format_align_center
                    </Icon>
                ) : styles.textAlign === 'right' ? (
                    <Icon>
                        format_align_right
                    </Icon>
                ) : (
                    <Icon>
                        format_align_justify
                    </Icon>
                )}
            </IconButton>
            <Popover
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}>
                <div>
                    <ToggleButtonGroup value={styles.textAlign}
                                       exclusive
                                       onChange={onChangeAlign}
                                       aria-label="align text"
                                       orientation={"vertical"}
                                       style={{flexDirection: 'column'}}
                    >
                        <ToggleButton
                            value="left"
                            aria-label="left"
                            style={{height: 36, borderRadius: 0, padding: 5}}>
                            <FormatAlignLeftIcon/>
                        </ToggleButton>
                        <ToggleButton
                            value="center"
                            aria-label="center"
                            style={{height: 36, padding: 5}}>
                            <FormatAlignCenterIcon/>
                        </ToggleButton>
                        <ToggleButton
                            value="right"
                            aria-label="right"
                            style={{height: 36, padding: 5, borderRadius: 0}}>
                            <FormatAlignRightIcon/>
                        </ToggleButton>
                        <ToggleButton
                            value="justify"
                            aria-label="justify"
                            style={{height: 36, padding: 5, borderRadius: 0}}>
                            <FormatAlignJustify/>
                        </ToggleButton>
                    </ToggleButtonGroup>
                </div>
            </Popover>
        </>
    )
};
const ColorPick = ({styles, setStyles}) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const onComplete = (color) => {
        setStyles({color: color})
    };
    return (
        <>
            <IconButton
                className={classes.iconButton}
                fontSize={"small"}
                style={{
                    borderRadius: 0,
                    padding: 5,
                    border: '1px solid #d8d8d8',
                    borderLeft: 'none'
                }}
                onClick={(e) => setAnchorEl(e.currentTarget)}
            >
                <FormatColorText/>
            </IconButton>
            <ColorPickerPopover
                open={Boolean(anchorEl)}
                close={() => setAnchorEl(null)}
                complete={onComplete}
                anchorEl={anchorEl}
                color={styles.color}
            />
        </>
    )
};
const BackgroundPick = ({styles, setStyles}) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const onComplete = (color) => {
        setStyles({background: color})
    };
    return (
        <>
            <IconButton
                className={classes.iconButton}
                fontSize={"small"}
                style={{
                    borderRadius: 0,
                    padding: 5,
                    border: '1px solid #d8d8d8',
                    borderLeft: 'none'
                }}
                onClick={(e) => setAnchorEl(e.currentTarget)}
            >
                <FormatColorFillIcon/>
            </IconButton>
            <ColorPickerPopover
                open={Boolean(anchorEl)}
                close={() => setAnchorEl(null)}
                complete={onComplete}
                anchorEl={anchorEl}
                color={styles.background}
            />
        </>
    )
};

//HEADER AND ACTIONS
const Header = () => {
    const classes = useStyles();
    return (
        <div className={classes.headerWrapper}>
            <Typography color={"textSecondary"} variant={"body1"}>
                Typography
            </Typography>
        </div>
    )
};
const Actions = ({apply, onClose}) => {
    const classes = useStyles();
    return (
        <div>
            <Button
                variant={'contained'}
                color={"primary"}
                size={"small"}
                onClick={apply}
                className={classes.actionButton}
            >Apply</Button>
            <Button
                variant={'contained'}
                color={"default"}
                size={"small"}
                onClick={onClose}
                className={classes.actionButton}
            >Cancel</Button>
        </div>
    )
};